var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSegritech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 72,
    viewBox: "0 0 143 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 142,
    height: 71,
    rx: 9.5,
    fill: "white",
    stroke: "#12489E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 108,
    height: 43,
    fill: "url(#pattern0_115_98)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_115_98",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_115_98",
    transform: "scale(0.00925926 0.0232558)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_115_98",
    width: 108,
    height: 43,
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegritech);
export default __webpack_public_path__ + "static/media/segritech.3f473dc66cd1019d427a89341d41a925.svg";
export { ForwardRef as ReactComponent };